<h2 class="secondary word-break">
    {{ 'tokens.browser.device.title' | apContent }}
</h2>
<p>{{ 'tokens.browser.device.info' | apContent }}</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <ap-grid-row>
        <ap-grid-col [sm]="6">
            <div class="ap-margin-bottom-4 ap-display-block">
                <ap-input
                    data-bb="device-input"
                    type="text"
                    apInputRef
                    (inputBlur)="onBlur()"
                    [label]="'tokens.browser.device.label' | apContent"
                    [formControl]="form.get('device') | apFormControl"
                    [attr.aria-label]="getAriaLabel()"
                    [messages]="errorMessage"
                >
                </ap-input>
                <p data-bb="help-text" class="ap-help-text">
                    <ap-content key="tokens.browser.device.helpText"></ap-content>
                </p>
            </div>
        </ap-grid-col>
    </ap-grid-row>

    <div class="ap-margin-bottom-4 ap-display-block">
        <div class="ap-flex ap-flex-row ap-flex-sm-column-reverse ap-flex-1">
            <ap-button (onClick)="goBack()" data-bb="back" variant="secondary" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.device.back' | apContent }}
            </ap-button>
            <ap-button type="submit" data-bb="submit" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.device.submit' | apContent }}
            </ap-button>
        </div>
    </div>
</form>
